import React from "react";
import { Route } from "react-router-dom";

import Login from "../pages/user/pages/login";
import BuyerLogin from "../pages/user/pages/buyerLogin";
import Signup from "../pages/user/pages/signup";
import BuyerSignup from "../pages/user/pages/buyerSignup";
import ForgetPassword from "../pages/user/pages/forgetPassword";
import MyCart from "../pages/user/pages/myCart";
import MyWishlist from "../pages/user/pages/myWishlist";
import ArtworkViewAll from "../pages/user/pages/artwork-all";
import MyAccount from "../pages/user/pages/myAccount";
import MyOrders from "../pages/user/pages/myOrders";
import Home from "../pages/user/pages/home";
import Artwork from "../pages/user/pages/artwork";
import Artworks from "../pages/user/pages/artworks"
import Artist from "../pages/user/pages/artist";
import CheckoutAddress from "../pages/user/pages/checkoutAddress";
import CheckoutPayment from "../pages/user/pages/checkoutPayment";
import PaymentSuccess from "../pages/user/pages/paymentSuccess";
import PaymentFailure from "../pages/user/pages/paymentFailure";
import OrderSummary from "../pages/user/pages/orderSummary";
import MyOrderDetails from "../pages/user/pages/myOrderDetails";
import Artists from "../pages/user/pages/artists";
import Exhibitions from "../pages/user/pages/exhibitions";
import ExhibitionLive from "../pages/user/pages/exhibitionLive";
import ExhibitionDetails from "../pages/user/pages/exhibitionDetails";
// Add other admin-specific imports...

const UserRoutes = () => {
  return (
    <>
      <Route path="/" element={<Home />} />
      <Route path="/artwork/:productTitleAndId" element={<Artwork />} />
      <Route path="/artworks/:id" element={<Artworks />} />
      <Route path="/artworks/:id/:type" element={<Artworks />} />
      <Route path="/artwork-all/:artworkType" element={<ArtworkViewAll />} />
      <Route path="/login" element={<Login />} />
      <Route path="/buyerLogin" element={<BuyerLogin />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/buyerSignup" element={<BuyerSignup />} />
      <Route path="/forgetPassword" element={<ForgetPassword />} />
      <Route path="/myCart" element={<MyCart />} />
      <Route path="/myWishlist" element={<MyWishlist />} />                 
      <Route path="/myAccount" element={<MyAccount />} />
      <Route path="/myOrders" element={<MyOrders />} />
      <Route path="/artist/:artistNameAndId" element={<Artist />} />

      <Route path="/checkoutAddress" element={<CheckoutAddress />} />
      <Route path="/checkoutPayment" element={<CheckoutPayment />} /> 
      <Route path="/paymentSuccess" element={<PaymentSuccess />} />
      <Route path="/paymentSuccess/:orderID" element={<PaymentSuccess />} />
      <Route path="/paymentFailure" element={<PaymentFailure />} />
      <Route path="/orderSummary" element={<OrderSummary />} />
      <Route path="/orderSummary/:orderID" element={<OrderSummary />} />
      <Route path="/myOrderDetails" element={<MyOrderDetails />} />
      <Route path="/myOrderDetails/:id" element={<MyOrderDetails />} />
      <Route path="/artists" element={<Artists />}/>
      <Route path="/exhibitions" element={<Exhibitions />} />
      <Route path="/exhibitionLive" element={<ExhibitionLive />} />
      <Route path="/exhibitionLive/:id" element={<ExhibitionLive />} />
      <Route path="/exhibitionDetails" element={<ExhibitionDetails />} />
      <Route path="/exhibitionDetails/:ids" element={<ExhibitionDetails />} />
      {/* Add other admin routes here */}
    </>
  );
};

export default UserRoutes;
